import { observer, useLocalObservable } from 'mobx-react';
import { Divider, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MyPageStore from '../store/MyPageStore';
import { toJS } from 'mobx';
import moreIcon from '../../../assets/image/moreIcon.png';
import { Dialog } from 'antd-mobile';

interface Props {
  pageStore: MyPageStore;
}

function MyPageMiddleArea(props: Props) {
  const navigate = useNavigate();
  const { pageStore } = props;

  const handleClickMoreBtn = () => {
    if (pageStore.totalEmojiCount === 0) {
      Dialog.alert({
        content: '내가 받은 이모티콘이 없습니다.',
        confirmText: '확인',
      });
      return;
    }
    navigate('/mypage/score-detail', {
      state: { myInfo: toJS(props.pageStore.myInfo) },
    });
  };

  return (
    <Grid
      container
      justifyContent={'space-between'}
      style={{
        border: '1px solid #dddddd',
        borderRadius: '10px',
        padding: '20px',
        marginTop: '20px',
      }}
    >
      <Grid>
        <Typography style={{ fontWeight: 500, fontSize: '16px', lineHeight: '16px' }}>내가 받은 이모티콘 수</Typography>
      </Grid>
      <Grid>
        <Typography
          style={{
            color: '#ABABAB',
            fontWeight: 500,
            fontSize: '11px',
            lineHeight: '14px',
            cursor: 'pointer',
          }}
          onClick={handleClickMoreBtn}
        >
          MORE
          <img
            src={moreIcon}
            alt='moreIcon'
            style={{
              marginLeft: '6px',
            }}
          />
        </Typography>
      </Grid>
      <Divider
        style={{
          border: '0.5px solid #eeeeee',
          marginTop: '13px',
          width: '100%',
        }}
      />
      <Grid container gap={2}>
        <Grid container justifyContent={'space-between'} style={{ marginTop: '23px' }}>
          <Typography
            style={{
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '14px',
            }}
          >
            최근30일
          </Typography>
          <Typography style={{ fontWeight: 500, fontSize: '18px', lineHeight: '18px' }}>
            <span
              style={{
                fontSize: '20px',
                lineHeight: '20px',
                color: '#2281D0',
                marginRight: '6px',
              }}
            >
              {pageStore.totalEmojiCount}
            </span>
            개
          </Typography>
        </Grid>
        {/* <Grid container justifyContent={"space-between"}>
          <Typography
            style={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "14px",
            }}
          >
            30일 평균
          </Typography>
          <Typography
            style={{ fontWeight: 500, fontSize: "18px", lineHeight: "18px" }}
          >
            <span
              style={{
                fontSize: "20px",
                lineHeight: "20px",
                color: "#2281D0",
                marginRight: "6px",
              }}
            >
              {pageStore.totalEmojiCount}
            </span>
            개
          </Typography>
        </Grid> */}
        {/* <Grid container justifyContent={"space-between"}>
          <Typography
            style={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "14px",
            }}
          >
            30일 평균
          </Typography>
          <Typography
            style={{ fontWeight: 500, fontSize: "18px", lineHeight: "18px" }}
          >
            <span
              style={{
                fontSize: "20px",
                lineHeight: "20px",
                color: "#2281D0",
                marginRight: "6px",
              }}
            >
              {pageStore.totalEmojiCount}
            </span>
            개
          </Typography>
        </Grid> */}
      </Grid>
    </Grid>
  );
}

export default observer(MyPageMiddleArea);
